import { RouletteData } from '../services/getRoulettes';

export function getUserRoulette(roulettes: RouletteData[]) {
  return roulettes.length ? roulettes[0] : null;
}
